module.exports = __webpack_public_path__ + "media/audio22.15be57e0.mp3";